import { render, staticRenderFns } from "./MyContract.vue?vue&type=template&id=0d224bab&scoped=true&"
import script from "./MyContract.vue?vue&type=script&lang=js&"
export * from "./MyContract.vue?vue&type=script&lang=js&"
import style0 from "./MyContract.vue?vue&type=style&index=0&id=0d224bab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d224bab",
  null
  
)

export default component.exports